import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: "AIzaSyCjwzd_-jGT9p-IJd6lKDQGYjoZaFmhIIc",
  authDomain: "ems-website-98f8d.firebaseapp.com",
  projectId: "ems-website-98f8d",
  storageBucket: "ems-website-98f8d.firebasestorage.app",
  messagingSenderId: "408907330992",
  appId: "1:408907330992:web:cc397fcc47f29796de5275",
  measurementId: "G-6ZLRM17BNH"
}

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

const auth = firebase.auth()
const db = firebase.firestore()
const storage = firebase.storage()

// Enable offline persistence
if (typeof window !== 'undefined') {
  db.enablePersistence({ synchronizeTabs: true })
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        console.warn('Persistence failed: Multiple tabs open')
      } else if (err.code === 'unimplemented') {
        console.warn('Persistence not available')
      }
    })
}

export { auth, db, storage }
export default firebase